import { invariant } from '@ui/utils/invariant';
import {
  holidaysToTradingViewInfo,
  parseSchedule,
  weekScheduleToTradingViewSession,
} from '@ui/utils/parseSchedule';

interface ParsedScheduleInfo {
  pythSession: string;
  pythTimezone: string;
  pythHolidays: string;
  pythCorrections: string;
}

export const getPythScheduleInfo = (
  schedule: string | undefined,
  symbolName: string,
): ParsedScheduleInfo => {
  invariant(schedule);

  const { timezone, weekSchedule, holidays } = parseSchedule(schedule);

  const pythSession = weekScheduleToTradingViewSession({
    weekSchedule,
    symbolName,
  });

  const { session_holidays, corrections } = holidaysToTradingViewInfo(holidays);

  return {
    pythSession,
    pythTimezone: timezone,
    pythHolidays: session_holidays,
    pythCorrections: corrections,
  };
};
